module.exports = __webpack_public_path__ + "img/맥형아카데미_7.e8a82d03.jpg";